module.exports = __webpack_public_path__ + "img/password-icon-input.3a207a8d.svg";